import type { EnvelopeStatus } from "../types/esign.types.ts"

type EnvelopeTagColor =
  | "default"
  | "processing"
  | "warning"
  | "success"
  | "error"

export const ENVELOPE_STATUS_TAG_COLORS: Record<
  EnvelopeStatus,
  EnvelopeTagColor
> = {
  draft: "default",
  sent: "warning",
  partially_signed: "processing",
  signed: "success",
  completed: "success",
  declined: "error",
  expired: "error",
  voided: "default"
}
